// Test IDs for common/shared components

export const MODAL_TEST_IDS = {
  PRICE: 'modal-price',
  PRIMARY_BTN: 'modal-primary-btn',
  SECONDARY_BTN: 'modal-secondary-btn',
  // Modal component accepts dynamic testId prop
} as const;

export const TOAST_TEST_IDS = {
  CONTAINER: 'toast-container',
  BTN: 'toast-btn',
} as const;

export const TOAST_MESSAGE_TEST_IDS = {
  CONTAINER: 'toast-message',
} as const;

export const ACCORDION_TEST_IDS = {
  TITLE_INFO: 'accordion-title-info',
  // Accordion component accepts dynamic title prop as testId
} as const;

export const TEXT_INPUT_TEST_IDS = {
  CLEAR_INPUT_BTN: 'clear-input-btn',
  // TextInput component accepts dynamic inputTestId prop
} as const;

export const TOOLTIP_TEST_IDS = {
  CONTAINER: 'tooltip',
  TITLE: 'tooltip-title',
  DESCRIPTION: 'tooltip-description',
} as const;

export const RADIO_CHECKBOX_TEST_IDS = {
  getContainer: (value: string) => `radio-container-${value}`,
  getInput: (value: string) => `radio-input-${value}`,
  getLabel: (value: string) => `radio-label-${value}`,
} as const;

